import { BlogPost } from 'common/types/entities/BlogPostListingInterface'
import { ImagePlacementVariants } from 'common/types/entities/LatestBlogPostsCarouselInterface'
import React from 'react'
import { BlogPostCardProps } from '.'
import BlogPostCard from './BlogPostCard'
import LayoutGridUi from './ui/LayoutGridUi'

type OneBackgroundThreeUnderLayoutProps = {
  blogPostCardProps: BlogPostCardProps
  posts: BlogPost[]
  oneElementInRow: boolean
}

function OneBackgroundThreeUnderLayout({
  posts,
  blogPostCardProps,
  oneElementInRow,
}: OneBackgroundThreeUnderLayoutProps) {
  return (
    <>
      {oneElementInRow ? (
        <div>
          {posts.map((post: BlogPost, index: number) => (
            <BlogPostCard
              key={index}
              post={post}
              {...blogPostCardProps}
              imagePlacement={ImagePlacementVariants.Background}
            />
          ))}
        </div>
      ) : (
        <LayoutGridUi gridTemplateColumns="1fr 1fr 1fr">
          {posts.map((post: BlogPost, index: number) => (
            <BlogPostCard key={index} post={post} {...blogPostCardProps} />
          ))}
        </LayoutGridUi>
      )}
    </>
  )
}
export default OneBackgroundThreeUnderLayout
